import React from "react";
import { STORE } from "../lib/store";
import Seo from "./Seo";

export default function UnderConstruction() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4" data-testid="under-construction-page">
      <Seo title="Under Construction" description="This site is under construction." noindex />
      <div className="text-center">
        <img src={STORE.logo} alt="Regal Jewels logo" className="w-24 h-24 sm:w-28 sm:h-28 mx-auto object-contain" data-testid="uc-logo" />
        <p className="font-heading text-2xl sm:text-4xl tracking-[0.25em] uppercase text-[#171310] mt-8">
          Under Construction.
        </p>
      </div>
    </div>
  );
}
